module.exports = __webpack_public_path__ + "img/poster2.5306f22b.png";